import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  start() {
    this.element.classList.add("loading")
    this.element.setAttribute("disabled", "")
  }

  reset() {
    this.element.classList.remove("loading")
    this.element.removeAttribute("disabled")
  }
}
